import type { HydrationError } from './types.ts';

/**
 * Returns a count of each hydration error type
 * (e.g. { SERVER_MISMATCH: 3, CLIENT_MISMATCH: 1 }) for lightweight
 * grouping in analytics, independent of the detailed logging gate.
 * Normalizes error types by removing "UNSAFE_" prefix.
 */
export const getHydrationErrorCounts = (
	hydrationErrors: HydrationError[],
): Record<string, number> => {
	const counts: Record<string, number> = {};
	for (const error of hydrationErrors) {
		if (error.type) {
			const normalizedType = error.type.startsWith('UNSAFE_') ? error.type.slice(7) : error.type;
			counts[normalizedType] = (counts[normalizedType] || 0) + 1;
		}
	}
	return counts;
};
